export const GET_ALL_PRODUCTCATEGORY_REQUEST = "GET_ALL_PRODUCTCATEGORY_REQUEST";
export const GET_ALL_PRODUCTCATEGORY_FAILURE = "GET_ALL_PRODUCTCATEGORY_FAILURE";
export const GET_ALL_PRODUCTCATEGORY_SUCCESS = "GET_ALL_PRODUCTCATEGORY_SUCCESS";

export const CREATE_PRODUCTCATEGORY_REQUEST = "CREATE_PRODUCTCATEGORY_REQUEST";
export const CREATE_PRODUCTCATEGORY_FAILURE = "CREATE_PRODUCTCATEGORY_FAILURE";
export const CREATE_PRODUCTCATEGORY_SUCCESS = "CREATE_PRODUCTCATEGORY_SUCCESS";

export const UPDATE_PRODUCTCATEGORY_REQUEST = "UPDATE_PRODUCTCATEGORY_REQUEST";
export const UPDATE_PRODUCTCATEGORY_FAILURE = "UPDATE_PRODUCTCATEGORY_FAILURE";
export const UPDATE_PRODUCTCATEGORY_SUCCESS = "UPDATE_PRODUCTCATEGORY_SUCCESS";

export const DELETE_PRODUCTCATEGORY_REQUEST = "DELETE_PRODUCTCATEGORY_REQUEST";
export const DELETE_PRODUCTCATEGORY_FAILURE = "DELETE_PRODUCTCATEGORY_FAILURE";
export const DELETE_PRODUCTCATEGORY_SUCCESS = "DELETE_PRODUCTCATEGORY_SUCCESS";